import * as React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import ZoneSelect from '../../components/cart/zone-select';
import { sumPrices } from '../../helpers/pricing-helpers';
import { UnseatedFlexCartItemProps } from '../../components/cart/unseated-flex-cart-item';


const UnseatedFlexCartItemView: React.StatelessComponent<UnseatedFlexCartItemProps> = props => {
    return (
        props.showSeatMapOnly ?
            <>
                <ZoneSelect showPriceTypeError={true} showSeatMapOnly={true} hideSeatMap={false} itemId={props.itemId} selectedZone={props.selectedZone} disabledZoneIds={[]} isSecondZone={false} />
            </>
            :
            <li key={props.itemId}>
                <div>
                    {
                        (props.itemTitle && props.showTitleAndRemoveButton) ?
                            <>
                                <div className="flex-between align-items-center">
                                    <p className="ace-subs-cart-item-info" data-demo-label={props.itemDateString !== '' ? "Performance Title" : "Package Title"}>
                                        <span>{props.itemTitle}</span>

                                    </p>
                                    {
                                        props.showRemoveButton ?
                                            <button type="button" className="btn-link" onClick={() => props.removeItem(props.itemIdToRemove)}>
                                                <span>{props.text.removeButtonText}</span>
                                            </button>
                                            : null
                                    }
                                </div>
                                <p><span className="bold">{props.itemDateString} </span></p>
                            </>
                            : null
                    }

                    {
                        props.showZoneDropdown ?
                            <ZoneSelect showSeatMapOnly={false} showPriceTypeError={true} hideSeatMap={props.hideSeatMap} itemId={props.itemId} selectedZone={props.selectedZone} disabledZoneIds={[]} isSecondZone={false} />
                            : null
                    }
                    {
                        props.itemProcessErrorMessage.length > 0 ?
                            <span className="field-validation-error">{props.itemProcessErrorMessage}</span>
                            : null
                    }
                </div>
            </li>
    );
}

export default UnseatedFlexCartItemView;